import React from "react";
import ViewTranditionalRaffleWinnerTableComponent from "./viewTranditionalRaffleWinnerTable.component";

export default function ViewTranditionalRaffleWinnerTableContainer({ data, lang }) {
  return <ViewTranditionalRaffleWinnerTableComponent data={data} lang={lang}/>;
}
